import { render } from "./credit-logs-dialog.vue?vue&type=template&id=dc8d9856&ts=true"
import script from "./credit-logs-dialog.vue?vue&type=script&lang=ts"
export * from "./credit-logs-dialog.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__